export default __webpack_public_path__ + "static/media/hand_01.954c6ff4.png";